document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-bundle-add]');
  if (!button || button.disabled) return;

  const variantIds = button
    .getAttribute('data-bundle-add')
    .split(',')
    .filter(Boolean)
    .map((id) => parseInt(id, 10));

  if (!variantIds.length) return;

  const cartDrawer = document.querySelector('cart-drawer');
  const errorEl = button.parentElement.querySelector('[data-bundle-error]');
  const originalText = button.textContent;

  button.disabled = true;
  button.classList.add('is-loading');
  button.textContent = 'Adding…';
  if (errorEl) errorEl.hidden = true;

  const body = {
    items: variantIds.map((id) => ({ id, quantity: 1 })),
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify(body),
  })
    .then((response) => {
      if (!response.ok) throw new Error('Bundle add failed');
      return response.json();
    })
    .then(() => {
      if (cartDrawer) {
        if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
        cartDrawer.open();
        if (typeof refreshCartDrawer === 'function') refreshCartDrawer();
      } else {
        window.location = window.routes.cart_url;
      }
    })
    .catch(() => {
      if (errorEl) errorEl.hidden = false;
    })
    .finally(() => {
      button.disabled = false;
      button.classList.remove('is-loading');
      button.textContent = originalText;
    });
});
